module.exports = __webpack_public_path__ + "img/4.06937f22.jpg";